import { Button, Form } from 'antd';
import { useStore } from 'zustand';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import { inventoryStore } from '../../../InventoryStore';

type EditInventoryActionsProps = {
  startTransition: React.TransitionStartFunction;
};

export const EditInventoryActions = ({
  startTransition,
}: EditInventoryActionsProps) => {
  const form = Form.useFormInstance();
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const cancelForm = useStore(inventoryStore, (state) => state.cancelForm);

  const setIsEditMode = useStore(
    inventoryStore,
    (state) => state.setIsEditMode
  );
  const formHasChanged = useStore(
    inventoryStore,
    (state) => state.formHasChanged
  );

  const handleSave = () => {
    amplitudeTrack('Click Save Extranet');
    startTransition(() => {
      form.submit();
    });
  };

  const onEdit = () => {
    amplitudeTrack('Click Edit Extranet');
    startTransition(() => {
      isEditMode ? handleSave() : setIsEditMode(true);
    });
  };

  const handleCancel = () => {
    amplitudeTrack('Click Cancel Extranet');
    startTransition(() => {
      cancelForm();
    });
  };

  return (
    <div className="edit-inventory-action">
      <div className="save-edit-action">
        {isEditMode && <Button onClick={handleCancel}>Cancel</Button>}
        <Button
          type="primary"
          onClick={onEdit}
          disabled={isEditMode && !formHasChanged}
        >
          {isEditMode ? 'Save' : 'Edit'}
        </Button>
      </div>
    </div>
  );
};
